const getClassName = (classNames) => {
    return classNames.map((className) => {
        if (className !== false) {
            return className
        }
        return false
    }).join(' ')
}

export default getClassName